document.addEventListener("DOMContentLoaded", () => {
  const section = document.querySelector("#ws-current-news");
  const results = section?.querySelector("[data-current-news-results]");
  const count = section?.querySelector("[data-current-news-count]");
  const status = section?.querySelector("[data-current-news-status]");
  const filterItems = section
    ? Array.from(section.querySelectorAll("[data-current-news-category]"))
    : [];
  const endpoint = section?.dataset.currentNewsEndpoint || "";
  const language = section?.dataset.currentNewsLanguage || "";

  if (
    !section ||
    !results ||
    !endpoint ||
    filterItems.length === 0 ||
    typeof window.fetch !== "function" ||
    typeof window.history?.pushState !== "function"
  ) {
    return;
  }

  const responseCache = new Map();
  let requestSequence = 0;
  let currentCategory =
    new URL(window.location.href).searchParams.get("news_category") || "alle";
  let currentPage = 1;

  const getPageFromUrl = (url) => {
    const parsedUrl = new URL(url, window.location.origin);
    const queryPage = Number.parseInt(
      parsedUrl.searchParams.get("news_page") ||
        parsedUrl.searchParams.get("paged") ||
        "",
      10
    );

    if (Number.isFinite(queryPage) && queryPage > 0) {
      return queryPage;
    }

    const pathMatch = parsedUrl.pathname.match(/\/page\/(\d+)\/?$/);
    return pathMatch ? Math.max(1, Number.parseInt(pathMatch[1], 10)) : 1;
  };

  currentPage = getPageFromUrl(window.location.href);

  const normalizeCategory = (category) =>
    filterItems.some(
      (item) => (item.dataset.currentNewsCategory || "alle") === category
    )
      ? category
      : "alle";

  currentCategory = normalizeCategory(currentCategory);

  const getItemForCategory = (category) =>
    filterItems.find(
      (item) =>
        (item.dataset.currentNewsCategory || "alle") ===
        normalizeCategory(category)
    ) || filterItems[0];

  const setActiveItem = (activeItem) => {
    filterItems.forEach((item) => {
      const isActive = item === activeItem;
      item.classList.toggle("is-active", isActive);

      if (isActive) {
        item.setAttribute("aria-current", "page");
      } else {
        item.removeAttribute("aria-current");
      }
    });
  };

  const getRequestUrl = (category, page = 1) => {
    const requestUrl = new URL(endpoint, window.location.origin);
    const normalizedCategory = normalizeCategory(category);

    if (normalizedCategory !== "alle") {
      requestUrl.searchParams.set("category", normalizedCategory);
    }

    requestUrl.searchParams.set("page", String(Math.max(1, page)));

    if (language) {
      requestUrl.searchParams.set("lang", language);
    }

    return requestUrl;
  };

  const fetchResults = (category, page = 1) => {
    const normalizedCategory = normalizeCategory(category);
    const normalizedPage = Math.max(1, page);
    const cacheKey = `${language}:${normalizedCategory}:${normalizedPage}`;

    if (responseCache.has(cacheKey)) {
      return responseCache.get(cacheKey);
    }

    const responsePromise = window
      .fetch(getRequestUrl(normalizedCategory, normalizedPage), {
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
        },
      })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Aktuelles request failed: ${response.status}`);
        }

        return response.json();
      })
      .then((payload) => {
        if (!payload || typeof payload.html !== "string") {
          throw new Error("Aktuelles response is incomplete.");
        }

        return payload;
      })
      .catch((error) => {
        responseCache.delete(cacheKey);
        throw error;
      });

    responseCache.set(cacheKey, responsePromise);
    return responsePromise;
  };

  const setLoading = (isLoading) => {
    section.classList.toggle("is-filter-loading", isLoading);
    results.setAttribute("aria-busy", isLoading ? "true" : "false");

    if (status && isLoading) {
      status.textContent = "Nachrichten werden geladen.";
    }
  };

  const replaceResults = async ({
    category,
    page = 1,
    url,
    skipHistory = false,
    fallbackToNavigation = true,
  }) => {
    const normalizedCategory = normalizeCategory(category);
    const normalizedPage = Math.max(1, page);
    const activeItem = getItemForCategory(normalizedCategory);
    const sequence = ++requestSequence;

    setActiveItem(activeItem);
    setLoading(true);

    try {
      const payload = await fetchResults(normalizedCategory, normalizedPage);

      if (sequence !== requestSequence) {
        return;
      }

      results.innerHTML = payload.html;

      if (count && typeof payload.count_label === "string") {
        count.textContent = payload.count_label;
      }

      currentCategory = normalizedCategory;
      currentPage = normalizedPage;

      if (!skipHistory && url) {
        window.history.pushState(
          {
            currentNewsCategory: currentCategory,
            currentNewsPage: currentPage,
          },
          "",
          url
        );
      }

      if (status) {
        status.textContent = `${payload.count_label || "Nachrichten"} geladen.`;
      }
    } catch (error) {
      if (sequence === requestSequence && fallbackToNavigation && url) {
        window.location.assign(url);
      }
    } finally {
      if (sequence === requestSequence) {
        setLoading(false);
      }
    }
  };

  const prefetchItem = (item) => {
    const category = item.dataset.currentNewsCategory || "alle";
    fetchResults(category, 1).catch(() => {});
  };

  filterItems.forEach((item) => {
    item.addEventListener(
      "pointerenter",
      () => {
        prefetchItem(item);
      },
      { once: true, passive: true }
    );
    item.addEventListener(
      "focus",
      () => {
        prefetchItem(item);
      },
      { once: true, passive: true }
    );
    item.addEventListener("click", (event) => {
      if (
        event.button !== 0 ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey
      ) {
        return;
      }

      event.preventDefault();

      const category = item.dataset.currentNewsCategory || "alle";

      if (
        normalizeCategory(category) === currentCategory &&
        currentPage === 1 &&
        !section.classList.contains("is-filter-loading")
      ) {
        return;
      }

      replaceResults({
        category,
        page: 1,
        url: item.href,
      });
    });
  });

  results.addEventListener("click", (event) => {
    const paginationLink = event.target.closest(".ws-pagination a");

    if (
      !paginationLink ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return;
    }

    event.preventDefault();

    const targetUrl = new URL(paginationLink.href, window.location.origin);
    const category =
      targetUrl.searchParams.get("news_category") || currentCategory;

    replaceResults({
      category,
      page: getPageFromUrl(targetUrl),
      url: targetUrl,
    }).then(() => {
      section.scrollIntoView({
        behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches
          ? "auto"
          : "smooth",
        block: "start",
      });
    });
  });

  window.addEventListener("popstate", () => {
    const targetUrl = new URL(window.location.href);
    const category = targetUrl.searchParams.get("news_category") || "alle";

    replaceResults({
      category,
      page: getPageFromUrl(targetUrl),
      url: targetUrl,
      skipHistory: true,
    });
  });
});
